<mat-toolbar>
    <a class="home" routerLink="/">
        <img src="assets/icons/logo.png" />
    </a>
</mat-toolbar>
<div class="flex row align-space-between justify-center">
    <div></div>
    <mat-card appearance="outlined" class="flex-60">
        @if (invitation$ | async; as invitation) {
            <mat-card-header>
                <h1 mat-card-title>Join {{ invitation.client.config.data.name }}</h1>
            </mat-card-header>
            <mat-card-content>
                <p>
                    <strong>{{ invitation.creator.email }}</strong> has invited you to join the "{{
                        invitation.client.config.data.name
                    }}" workspace
                </p>
                <div>
                    <p>Fill in your name and then click Join to accept the invitation</p>
                    <form [formGroup]="form" class="flex column">
                        <mat-form-field appearance="fill">
                            <mat-label>Name</mat-label>
                            <input matInput required formControlName="name" />
                        </mat-form-field>
                        @if (invitation.user === null) {
                            <mat-form-field appearance="fill">
                                <mat-label>Email</mat-label>
                                <input matInput required type="email" formControlName="email" />
                            </mat-form-field>
                        }
                    </form>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button
                    mat-flat-button
                    color="primary"
                    [class.spinner]="loading"
                    [disabled]="!form.valid || loading"
                    (click)="accept()"
                >
                    Accept
                </button>
            </mat-card-actions>
        }
        @if (error) {
            <mat-card-footer>
                <mat-card appearance="outlined" class="error">{{ error }}</mat-card>
            </mat-card-footer>
        }
    </mat-card>
    <div></div>
</div>
